module.exports = __webpack_public_path__ + "img/tpc-13.b0496c1f.webp";